exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*:host {\n  background-color: #106cc8;\n  color: rgba(255, 255, 255, 0.87);\n  display: block;\n  height: 48px;\n  padding: 0 16px;\n}\n\nh1 {\n  display: inline;\n  font-size: 20px;\n  font-weight: normal;\n  letter-spacing: 0.1px;\n  line-height: 48px;\n}\n\n.more {\n  background: url(\"./assets/svg/more.svg\");\n  float: right;\n  height: 24px;\n  margin-top: 12px;\n  width: 24px;\n}*/\n:host {\n  z-index: 9999; }\n.fixed.menu {\n  height: 50px;\n  background-color: #fff;\n  border-bottom: 1px solid #c2cfd6; }\n.user-menu {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/shared/toolbar/toolbar.component.scss
// module id = ../../../../../src/app/shared/toolbar/toolbar.component.scss
// module chunks = main